<template>
  <v-card>
    <v-card-title class="text-left px-4 pt-4" v-if="label">{{ label }}</v-card-title>

    <v-card-text>
      <v-btn-toggle class="toggle" borderless dense group :mandatory="mandatory" :value="innerValue" @change="onChange">
        <v-btn
          class="toggle-btn"
          color="primary"
          width="33%"
          v-ripple="{ class: `primary--text` }"
          :disabled="disabled"
          :value="1"
        >
          Да
        </v-btn>
        <v-btn
          class="toggle-btn"
          color="primary"
          width="33%"
          v-ripple="{ class: `primary--text` }"
          :disabled="disabled"
          :value="0"
        >
          Нет
        </v-btn>
        <v-btn
          class="toggle-btn"
          color="primary"
          width="33%"
          v-ripple="{ class: `primary--text` }"
          :disabled="disabled"
          :value="'not-selected'"
        >
          Не выбрано
        </v-btn>
      </v-btn-toggle>
    </v-card-text>

    <div v-for="(err, idx) in errorMessages" :key="`${err}-${idx}`" class="pb-2 pl-4 error--text">
      {{ err }}
    </div>
  </v-card>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "BoolGroup",

  props: {
    label: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    value: {},
  },

  data() {
    return {
      mandatory: false,
      hasValue: false,
    };
  },

  computed: {
    innerValue() {
      if (this.value === true) {
        return 1;
      }

      if (this.value === false && this.value !== "") {
        return 0;
      }

      if (this.value === null || this.value === "") {
        return "not-selected";
      }

      return this.value;
    },
  },

  methods: {
    onChange(val) {
      // Если было действие с кнопкой активируем режим при котором нельзя снять значения кнопки
      if (!this.mandatory) {
        this.mandatory = true;
      }

      if (val === "not-selected") {
        this.$emit("input", "");
        return;
      }

      this.$emit("input", val);
    },
  },
});
</script>

<style scoped lang="scss">
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  color: #3c4858;
}

.theme--light.v-btn {
  &::before {
    background-color: #fff;
    opacity: 1;
  }
}

.theme--light.v-btn--active:hover,
.theme--light.v-btn--active {
  color: #fff !important;

  &::before {
    background-color: #00cae3;
    opacity: 1;
  }
}

.toggle {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
